import { createSlice } from '@reduxjs/toolkit';
import { REQUIRED_JOB_TAGS } from '../../Editor/StructureTag/constants/jobStructureTags';

const requiredTags = Object.keys(REQUIRED_JOB_TAGS);
const INITIAL_STATE = {
  jobTags: requiredTags,
};

export const JobSlice = createSlice({
  name: 'job',
  initialState: INITIAL_STATE,
  reducers: {
    addJobTag: (state, { payload }) => {
      state.jobTags.push(payload);
    },
  },
});

export const jobTagsSelector = state => state.job.jobTags;

export const { addJobTag } = JobSlice.actions;

export default JobSlice.reducer;
